export const IconArrowLeft = ({size = 14}: { size?: number }) => {
    return <svg width={size} viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6 11.25L1 6M1 6L6 0.75M1 6L13 6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"
              strokeLinejoin="round"/>
    </svg>

}
